import { Expose } from "class-transformer";
import { Model } from "../../shared-features/models/model";

export class TrucksCounts extends Model {
    @Expose() totalFreelanceTrucksCount: number;
    @Expose() totalFleetsTrucksCount: number;
    @Expose() lastRefreshTime:Date;
}
